import React, { Fragment, useEffect, useState } from "react";
import { Collapse, IconButton } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  generateSummaryReportService,
  getVerifierEmissionSummary,
} from "../../../services/emissionService";
import { useNavigate } from "react-router-dom";
import { STEPS } from "../../../constants/enums";
import {
  dateParserWithoutTime,
  parseDate,
  toastMessage,
} from "../../../helper";
import { successMessage } from "../../../constants/messageConstants";

const ExternalAuditSummary = (props: any) => {
  const { setStep } = props;
  const navigate = useNavigate();
  const [facilitySummary, setFacilitySummary] = useState<any>();
  const [categorySummary, setCategorySummary] = useState<any>();
  const [scopeSummary, setScopeSummary] = useState<any>();
  const [gasSummary, setGasSummary] = useState<any>();

  const [isLoading, setIsLoading] = useState(false);

  // Single state variable to manage open/close state of all sections
  const [openSections, setOpenSections] = useState<any>({
    facility: true,
    category: true,
    scope: true,
    gas: true,
  });

  useEffect(() => {
    getVerifierEmissionSummary().then((res: any) => {
      const data = res.data;
      setFacilitySummary(data.t3);
      setCategorySummary(data.t1);
      setScopeSummary(data.t2);
      setGasSummary(data.t4);
    });
  }, []);

  // Function to toggle the open/close state of each section
  const toggleSection = (section: string) => {
    setOpenSections((prevOpenSections: any) => ({
      ...prevOpenSections,
      [section]: !prevOpenSections[section],
    }));
  };

  function downloadSummaryReport() {
    let reqObj: any = {};
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
    let user = JSON.parse(localStorage.getItem("user") || "{}");
    let auditRequestId =
      localStorage.getItem("auditRequestId") &&
      JSON.parse(localStorage.getItem("auditRequestId") || "");
    reqObj.company = company;
    reqObj.auditor = user.id;
    reqObj.auditRequest = auditRequestId;
    reqObj.companyName =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "")?.name;
    reqObj.reportPeriod =
      dateParserWithoutTime(localStorage.getItem("from_date") || "") +
      " - " +
      dateParserWithoutTime(localStorage.getItem("to_date") || "");

    generateSummaryReportService(reqObj)
      .then(async (res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SummaryReport.xlsx");
        document.body.appendChild(link);
        link.click();
        toastMessage(successMessage().GENERATE_SUCCESS, "success");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      });
  }

  return (
    <Fragment>
      <div className="px-10 pt-5">
        <div>
          <div className="pw-input-label pw-create-label">Emission Summary</div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {/* Lorem ipsum dolor sit amet. */}
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-row justify-between items-center py-4">
            <div className="flex flex-col gap-2">
              <div className="text-sm text-neutral-600">
                Company name:
                <span className="text-neutral-800">
                  {" "}
                  {localStorage.getItem("company") &&
                    JSON.parse(localStorage.getItem("company") || "")?.name}
                </span>
              </div>
              <button
                className="pw-bunit-button-primary pw-bunit-button-save text-white bg-primary"
                onClick={() => downloadSummaryReport()}
              >
                Report
              </button>
              <div className="text-sm text-neutral-600">
                Reporting Period:
                <span className="text-neutral-800">
                  {" "}
                  {localStorage.getItem("from_date") &&
                    dateParserWithoutTime(
                      localStorage.getItem("from_date") || ""
                    )}
                </span>
                <span className="text-neutral-800">
                  {" - "}
                  {localStorage.getItem("to_date") &&
                    dateParserWithoutTime(
                      localStorage.getItem("to_date") || ""
                    )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-y-auto h-full w-full">
          <div className="pw-blist-header w-full flex flex-row justify-end"></div>

          <div className="h-80v pw-hide-scroll overflow-y-auto">
            {Object.entries(openSections).map(([section, isOpen]: any) => (
              <Fragment key={section}>
                <table className="w-full border-collapse">
                  <thead className="pw-custom-head">
                    <tr>
                      <th
                        className="text-sm text-neutral-600 border border-neutral-200 p-2 items-center w-full flex justify-between pw-cursor-pointer"
                        colSpan={3}
                        onClick={() => toggleSection(section)} // Toggle the state of the section
                      >
                        {section === "facility"
                          ? "Facility level total emissions (tCO2e)"
                          : section === "category"
                          ? "Category specific emissions (tCO2e)"
                          : section === "scope"
                          ? "Scope level emissions (tCO2e)"
                          : "Emissions wrt GHGs (tCO2e)"}
                        <IconButton
                          className="pw-collapse-icon"
                          aria-label="expand row"
                          size="small"
                        >
                          {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                        </IconButton>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                      <tr>
                        {section === "facility"
                          ? facilitySummary?.map(
                              (eachData: any, index: number) => (
                                <tr key={index}>
                                  <td
                                    className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                    style={{ width: "30rem" }}
                                  >
                                    {eachData.code}
                                  </td>
                                  <td
                                    className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                    style={{ width: "30rem" }}
                                  >
                                    {eachData.total_emissions}
                                  </td>
                                </tr>
                              )
                            )
                          : section === "category"
                          ? categorySummary?.map(
                              (eachData: any, index: number) => (
                                <tr key={index}>
                                  <td
                                    className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                    style={{ width: "30rem" }}
                                  >
                                    {eachData.code}
                                  </td>
                                  <td
                                    className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                    style={{ width: "30rem" }}
                                  >
                                    {eachData.total_emissions}
                                  </td>
                                </tr>
                              )
                            )
                          : section === "scope"
                          ? scopeSummary?.map(
                              (eachData: any, index: number) => (
                                <tr key={index}>
                                  <td
                                    className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                    style={{ width: "30rem" }}
                                  >
                                    {eachData.code}
                                  </td>
                                  <td
                                    className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                    style={{ width: "30rem" }}
                                  >
                                    {eachData.total_emissions}
                                  </td>
                                </tr>
                              )
                            )
                          : gasSummary?.map((eachData: any, index: number) => (
                              <tr key={index}>
                                <td
                                  className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                  style={{ width: "30rem" }}
                                >
                                  {eachData.code}
                                </td>
                                <td
                                  className="border border-neutral-200 p-3 pw-e2e-categorytype bg-white"
                                  style={{ width: "30rem" }}
                                >
                                  {eachData.total_emissions}
                                </td>
                              </tr>
                            ))}
                      </tr>
                    </Collapse>
                  </tbody>
                </table>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={() => navigate("/log/Emissions")}
        >
          Cancel
        </div>
        <button
          className="pw-bunit-button-primary pw-bunit-button-save text-white bg-primary"
          onClick={() => setStep(STEPS.UPLOAD_CERTIFICATE)}
        >
          Next
        </button>
      </div>
    </Fragment>
  );
};

export default ExternalAuditSummary;
